module.exports = __webpack_public_path__ + "media/bridge_reference1.ece318c1.mp3";